import { useMutation } from '@tanstack/react-query';
import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { api } from '../api.ts';
import { Button, ErrorBox } from './ui.tsx';

/**
 * Exportar em Excel, igual em todas as listas (ADR 0087). A API refaz a consulta da tela com os
 * mesmos filtros e as mesmas permissões, só aceita as colunas que a tela permite e registra a
 * exportação no histórico. Os títulos das colunas e o texto de cada código vão já traduzidos.
 * Quando o filtro é feito na própria tela, ela passa os ids das linhas visíveis (`ids`).
 */
export function ExportButton({
  path,
  filters,
  columns,
  values,
  ids,
  label,
}: {
  path: string;
  filters: Record<string, string>;
  columns: { key: string; label: string }[];
  /** Texto de cada código por coluna (ex.: situação "active" → "Ativo"). */
  values?: Record<string, Record<string, string>>;
  /** Ids das linhas visíveis, quando a tela filtra a lista sozinha. */
  ids?: string[];
  /** Rótulo próprio, quando a tela tem mais de uma exportação. */
  label?: string;
}) {
  const { t } = useTranslation();
  const run = useMutation({
    mutationFn: () =>
      api.download(path, {
        filters,
        columns,
        ...(values ? { values } : {}),
        ...(ids ? { ids } : {}),
      }),
  });
  return (
    <span className="inline-flex flex-col gap-2">
      <Button
        variant="secondary"
        disabled={run.isPending}
        title={t('dataExport.hint')}
        onClick={() => run.mutate()}
      >
        <Download size={16} aria-hidden />
        {run.isPending ? t('dataExport.exporting') : (label ?? t('dataExport.button'))}
      </Button>
      <ErrorBox error={run.error} />
    </span>
  );
}
